<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useRouter } from "vue-router"
import { useI18n } from "vue-i18n"
import type { BreadcrumbItem } from "@core/components/layout/header/HeaderPage.vue"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Ajout de plusieurs bâtiments et compteurs",
            breadcrumbHome: "Accueil",
        },
    },
})

// ================================
// ROUTER
// ================================
const router = useRouter()

// ================================
// COMPUTED
// ================================
const getBreadcrumb = computed<BreadcrumbItem[]>(() => [
    { label: t("breadcrumbHome"), icon: "pi pi-home", route: "/" },
    { label: t("title") },
])

// ================================
// HANDLERS
// ================================
/**
 * Fin du parcours multi : retour à l’accueil.
 */
function onDoneForm(): void {
    router.push({ path: "/" })
}
</script>

<template>
    <div class="page page-building-append-multi-meters">
        <HeaderPage :title="t('title')" :breadcrumb="getBreadcrumb" />

        <BaseCard class="mx-auto w-full max-w-screen-lg p-6">
            <template #content>
                <SourceMultiAppendForm
                    class="mx-auto"
                    @done:form="onDoneForm"
                />
            </template>
        </BaseCard>
    </div>
</template>
